'use es6';

import PropTypes from 'prop-types';
import classnames from 'classnames';
import { NavMarker } from 'react-rhumb';
import I18n from 'I18n';
import UIImage from 'UIComponents/image/UIImage';
import imageUrl from 'bender-url!FileManagerImages/images/no-results.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function EmptySearchResults(props) {
  const {
    className
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    className: classnames('no-results', className),
    "data-test-id": "empty-search-results",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "SEARCH_NO_RESULTS"
    }), /*#__PURE__*/_jsx(UIImage, {
      className: "m-y-10",
      width: 100,
      src: imageUrl,
      responsive: false
    }), /*#__PURE__*/_jsx("h4", {
      children: I18n.text('FileManagerDashboard.noResults.message')
    }), /*#__PURE__*/_jsx("p", {
      children: I18n.text('FileManagerDashboard.noResults.hint')
    })]
  });
}
EmptySearchResults.propTypes = {
  className: PropTypes.string
};